


































































































































































































































































































































































































































































/* eslint-disable */
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { Component, Vue } from 'vue-property-decorator';
import LayoutContent from '@/components/LayoutContent.vue';
import FormInput from '@/components/FormInput.vue';
import Select from '@/components/Select.vue';
import { quillEditor } from 'vue-quill-editor';
import Button from '@/components/Button.vue';
import Checkbox from '@/components/Checkbox.vue';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import api from '@/libs/api';

import Preview from './OnepayMerchantSettingPreview.vue';

@Component({
  components: {
    LayoutContent,
    FormInput,
    Select,
    quillEditor,
    Button,
    Checkbox,
    Preview,
  },
})
export default class MerchantSetting extends Vue {
  receiptData: any = {
    receipt_id: '',
    receipt_us: '',
  }

  termsData: any = {
    terms_id: '',
    terms_us: '',
  }

  smtpData: any = {
    smtpHost: '',
    smtpSecure: '',
    smtpPort: '',
    smtpUsername: '',
    smtpPassword: '',
    smtpFrom: '',
    smtpFromName: '',
    smtpReplyTo: '',
    smtpReplyToName: '',
  }

  layoutSetting: any = {
    title: '',
    favicon: '',
    logo_footer_color: '#391C17',
    header_bar_head_box_color: '#222222',
    side_background_color: '#F3F3F4',
    side_footer_banner_color: '#FFFFFF',
    action_button_color: '#B0A16C',
    font_inside_box_color: '#F7931D',
    font_inside_head_box_color: '#FFFFFF',
    fontFamily: '',
    logo: '',
    top_banner: '',
    bottom_banner: '',
    boxShadow: true,
  };

  editorOption = {
    modules: {
      toolbar: [
        ['bold', 'italic'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'indent': '-1' }, { 'indent': '+1' }],
        ['link']
      ],
    }
  };

  mounted() {
    this.getData();
  }

  async getData() {
    const userRole = this.$route.params.user_role;
    const userGroup = this.$route.params.user_group;
    const merchId = this.$route.params.merch_id;
    try {
      const { data } = await api.get('/onepay/merchants_detail', {
        params: {
          user_role: userRole,
          user_group: userGroup,
          merch_id: merchId,
        },
      });
      console.log("data", data);
      if (data.config.receipt) {
        const receipt = JSON.parse(data.config.receipt)
        this.receiptData.receipt_id = receipt.id;
        this.receiptData.receipt_us = receipt.us;
      }

      if (data.config.terms) {
        const terms = JSON.parse(data.config.terms)
        this.termsData.terms_id = terms.id;
        this.termsData.terms_us = terms.us;
      }

      for (const key in this.smtpData) {
        this.smtpData[key] = data.config[key];
      }

      for (const key in this.layoutSetting) {
        this.layoutSetting[key] = data.config[key] || this.layoutSetting[key];
      }

    } catch (err) {
      console.error(err);
    }
  }

  saveData(section: string) {
    try {
      api.post('onepay/merchants_setting', {
        ...this.receiptData,
        ...this.termsData,
        ...this.smtpData,
        ...this.layoutSetting,
        merch_id: this.$route.params.merch_id,
        user_role: this.$route.params.user_role,
        user_group: this.$route.params.user_group,
      }).then((result: any) => {
        if (result.data.status) {
          showToast(ToastType.SUCCESS, 'Save Success', 'Your change(s) has been saved');
        } else {
          showToast(ToastType.FAILED, 'Save Failed', result.data.message);
        }
      }).catch((error: any) => {
        showToast(ToastType.FAILED, 'Save Failed', 'An Error Occured');
      })
    } catch (error) {
      console.log(error);
    }
  }
}
